import React from 'react';
import { Avatar, Tooltip } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { getFullBlobUrl } from '@app/utils/blobUrl';
import { avatarColor } from './userAvatarColor';
import './UserAvatar.css';

interface UserAvatarProps {
  /** Tên người dùng (vd: giá trị `created_by`). */
  name?: string | null;
  /** Ảnh đại diện của user; không có thì dùng icon mặc định. */
  avatarUrl?: string | null;
  size?: number;
  /** Ẩn tên khi chỉ muốn hiển thị avatar. */
  showName?: boolean;
  className?: string;
}

/** Avatar + tên người dùng, dùng chung cho các cột "Người tạo"/"Tạo bởi". */
const UserAvatar: React.FC<UserAvatarProps> = ({ name, avatarUrl, size = 22, showName = true, className }) => {
  if (!name) return <span className="user-avatar__empty">—</span>;

  const src = getFullBlobUrl(avatarUrl || undefined);

  return (
    <Tooltip title={name}>
      <span className={['user-avatar', className].filter(Boolean).join(' ')}>
        <Avatar
          size={size}
          src={src}
          icon={<UserOutlined style={{ fontSize: Math.round(size * 0.55) }} />}
          className="user-avatar__icon"
          style={src ? undefined : { backgroundColor: avatarColor(name) }}
        />
        {showName && <span className="user-avatar__name">{name}</span>}
      </span>
    </Tooltip>
  );
};

export default UserAvatar;
